import repository from "@/api/modules/Accounting/DebitMemoHistory";

export default {
    state: {
        
    },
    getters: {
        
    },
    actions: {
        postDebitMemoHistory({commit},payload) {
            return new Promise((resolve, reject) => {
                repository.postdebitmemohistory(payload).then((response) => {
                    if (response.status == 200) {
                        resolve(response)
                    }
                }).catch((error) => {
                    reject(error)
                });
            })
        },
        getDebitMemoHistory({commit},payload) {
            return new Promise((resolve, reject) => {
                repository.getdebitmemohistory(payload).then((response) => {
                    if (response.status == 200) {
                        resolve(response)
                    }
                }).catch((error) => {
                    reject(error)
                });
            })
        },
        putDebitMemoHistory({commit},payload) {
            return new Promise((resolve, reject) => {
                repository.putdebitmemohistory(payload).then((response) => {
                    if (response.status == 200) {
                        resolve(response)
                    }
                }).catch((error) => {
                    reject(error)
                });
            })
        },
    },
    mutations: {

    }

}
